import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from '@/components/ui/form';
import { VoiceIntegration } from '@/shared/types/integration';
import { DEFAULT_START_MESSAGE } from '@/util/constants';

import PreferenceCheckbox from './PreferenceCheckbox';
import CardBase from '../../Components/CardBase';

/**
 * Preferences configuration card for voice integrations
 *
 * Contains preference checkboxes:
 * - Call Recording: Controls whether voice calls are recorded and stored
 * - AI Agent starts first: Controls whether the AI agent starts the conversation
 */
const Preferences = ({ children }: { children?: React.ReactNode }) => {
  const { t } = useTranslation();
  const { control } = useFormContext<VoiceIntegration>();

  return (
    <CardBase title={t('integrations.voice_common.preferences')}>
      <FormField
        control={control}
        name="config.call_recording"
        render={({ field }) => (
          <PreferenceCheckbox
            title={t('integrations.voice_common.call_recording_title')}
            description={t('integrations.voice_common.call_recording_description')}
            checked={field.value ?? false}
            onCheckedChange={field.onChange}
          />
        )}
      />

      <FormField
        control={control}
        name="config.welcome_trigger_message"
        render={({ field }) => (
          <PreferenceCheckbox
            title={t('integrations.voice_common.welcome_trigger_message')}
            description={t('integrations.voice_common.welcome_trigger_message_description')}
            checked={field.value === DEFAULT_START_MESSAGE}
            onCheckedChange={(checked) =>
              field.onChange(checked ? DEFAULT_START_MESSAGE : undefined)
            }
          />
        )}
      />
      {children}
    </CardBase>
  );
};

export default Preferences;
